export default {
  palette: {
    primary: { main: '#2EA1F8' },
  },
  typography: {
    useNextVariants: true,
    fontFamily: 'Rubik, Helvetica, sans-serif',
  },
};
